import * as React from "react";
const SvgFiRrTrashSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-trash-slash_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-3.778-3.778L21.115 6H22a1 1 0 1 0 0-2h-4.1A5.01 5.01 0 0 0 13 0h-2a5.01 5.01 0 0 0-4.899 4s-.656.001-.683.004L1.708.294A.999.999 0 1 0 .292 1.706l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414m-5.613-5.613L7.414 6h11.692zM11 2h2c1.304 0 2.415.836 2.828 2H8.172A3 3 0 0 1 11 2m6.845 19.845a1 1 0 0 1-.309 1.38c-.8.507-1.725.775-2.675.775H9.134a4.98 4.98 0 0 1-4.977-4.52l-.902-9.384a1 1 0 0 1 .9-1.09c.562-.069 1.038.35 1.091.898l.902 9.383A2.987 2.987 0 0 0 9.134 22h5.727c.57 0 1.125-.16 1.604-.465a1 1 0 0 1 1.38.31"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-trash-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrashSlash;
